import React, { FC, useContext } from 'react'
import { Trans, t } from '@lingui/macro'
import { IconCircleNotStarted } from '../../../components/common/icon/IconCircleNotStarted'
import { IconCircleProgress } from '../../../components/common/icon/IconCircleProgress'
import { AnalyticsHighlight } from '../AnalyticsHighlight'
import { AnalyticsHeader } from '../AnalyticsHeader'
import BorderedBox from '../../../components/common/bordered-box/BorderedBox'
import WorkbooksOverviewTable from './WorkbooksOverviewTable'
import Loader from '../../../components/common/loader/Loader'
import { useWorkbooksAnalyticsQuery } from './WorkbooksAnalytics.codegen'

import './Workbooks.less'
import { AnalyticsContext } from '../AnalyticsContext'
import { AnalyticsFiltersEnum } from 'front-end/src/pages/analytics/constants'

const Workbooks: FC<{
  showFilterPanel?: boolean
}> = ({ showFilterPanel }) => {
  const { filterAsQueryVariables } = useContext(AnalyticsContext)
  const { data, loading } = useWorkbooksAnalyticsQuery({
    fetchPolicy: 'no-cache',
    variables: {
      filter: filterAsQueryVariables
    }
  })

  if (loading) {
    return <Loader />
  }
  if (!data?.analytics.workbooks) {
    return null
  }

  const {
    analytics: {
      workbooks: {
        completedCount,
        inProgressCount,
        notStartedCount,
        overdueCount
      }
    }
  } = data

  return (
    <>
      <AnalyticsHeader
        showFilterPanel={showFilterPanel}
        activeFilters={[
          AnalyticsFiltersEnum.INCLUDE_ADMINS,
          AnalyticsFiltersEnum.INCLUDE_ARCHIVED,
          AnalyticsFiltersEnum.INCLUDE_DRAFTS,
          AnalyticsFiltersEnum.DATE_FILTER,
          AnalyticsFiltersEnum.WORKSPACE_FILTER,
          AnalyticsFiltersEnum.GROUP_FILTER
        ]}
      >
        <Trans>Enrolments</Trans>
      </AnalyticsHeader>

      <>
        <div className="AnalyticsRow">
          <BorderedBox className="AnalyticsRow__box">
            <div className="AnalyticsHighlight__row">
              <AnalyticsHighlight
                value={completedCount}
                icon="check"
                description={t`Completed`}
                iconColor="green"
              />
              <AnalyticsHighlight
                value={inProgressCount}
                icon={<IconCircleProgress boxSize="20px" />}
                description={t`In progress`}
                iconColor="blue"
              />
              <AnalyticsHighlight
                value={notStartedCount}
                icon={<IconCircleNotStarted boxSize="20px" />}
                description={t`Not started`}
                iconColor="grey"
              />
              <AnalyticsHighlight
                value={overdueCount}
                icon="clock"
                description={t`Overdue`}
                iconColor="red"
              />
            </div>
          </BorderedBox>
        </div>
        <WorkbooksOverviewTable />
      </>
    </>
  )
}

export default Workbooks
